<template>
    <div>
        <h2 class="m-0 h1 text-uppercase text-center">{{$t('eventos.sesiones_selecion')}}</h2>
        <div class="subtitle h3 light mb-3 mb-lg-4 mb-lg-5 text-center">
            {{ $t(!productos ? 'eventos.sesiones_elige' : 'productos.sesion') }}
        </div>
        <b-row class="pstn_btn">
            <b-col v-for="(sesion, index) in sesiones" lg="3" md="6" sm="12" :key="index" class="p-1 text-center mrgn_rgt">
                <router-link 
                    v-if="productos || sesion.entradas_libres"
                    :to="calcularRuta(sesion, event)"
                    class="button large-button mr-md-3 mb-md-0 mb-2 btn_wid"
                >
                    <span class="dia">{{ sesion.fecha_formateada }}</span>
                    <span class="hora">
                        <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <path class="icono_hora" d="M8,0C3.58,0,0,3.58,0,8s3.58,8,8,8,8-3.58,8-8S12.42,0,8,0ZM8,14c-3.31,0-6-2.69-6-6s2.69-6,6-6,6,2.69,6,6-2.69,6-6,6ZM13,8c0,.55-.45,1-1,1h-4c-.55,0-1-.45-1-1v-3c0-.55.45-1,1-1s1,.45,1,1v2h3c.55,0,1,.45,1,1Z" fill="#000" stroke-width="0"/>
                        </svg>
                        {{ sesion.hora_formateada }}
                    </span> 
                </router-link>
                <button 
                    v-else-if="sesion.entradas_a_la_venta_proximamente"
                    class="disabled button large-button mr-md-3 mb-md-0 mb-2 btn_dis"
                >
                    <span class="dia_dis">{{ sesion.fecha_formateada }}</span>
                    <span class="hora_dis">
                        <span>{{ $t('partidos.proximamente') }}</span>
                    </span> 
                </button>
                <button 
                    v-else-if="!sesion.entradas_libres"
                    class="disabled button large-button mr-md-3 mb-md-0 mb-2 btn_dis"
                >
                    <span class="dia_dis">{{ sesion.fecha_formateada }}</span>
                    <span class="hora_dis">
                        <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                            <path class="icono_hora_dis" d="M8,0C3.58,0,0,3.58,0,8s3.58,8,8,8,8-3.58,8-8S12.42,0,8,0ZM8,14c-3.31,0-6-2.69-6-6s2.69-6,6-6,6,2.69,6,6-2.69,6-6,6ZM13,8c0,.55-.45,1-1,1h-4c-.55,0-1-.45-1-1v-3c0-.55.45-1,1-1s1,.45,1,1v2h3c.55,0,1,.45,1,1Z" fill="#000" stroke-width="0"/>
                        </svg>
                        <template v-if="!sesion.venta_cerrada">
                            {{ sesion.hora_formateada  + ' (' + $t(!event.reserva_instalaciones ? 'partidos.agotadas' : 'partidos.reservas_agotadas').toUpperCase() + ')' }}
                        </template>
                        <template v-else>
                            {{ sesion.hora_formateada  + ' (' + $t('partidos.venta_cerrada').toUpperCase() + ')' }}
                        </template>
                    </span> 
                </button>
            </b-col>
        </b-row>
    </div>

</template>

<script>
    export default {
        props: ['event', 'sesiones', 'productos'],
        methods: {
            calcularRuta(sesion, event) {
                if (this.productos) {
                    return {
                        name: 'front.productos.show',
                        params: {
                            slug: event.slug,
                            sesion_id: sesion.id
                        },
                    };
                } else {
                    return {
                        name: 'front.eventos.show.slug',
                        params: {
                            event_id: event.id,
                            sesion_id: sesion.id,
                            slug: event.slug
                        },
                    };
                }
            }
        }
    }
</script>

<style scoped>
.pstn_btn {
    display: flex !important;
    justify-content: center !important;
    flex-wrap: wrap !important;
}

.btn_wid {
    background-color: white !important;
    border: 4px solid;   
    border-color: red; /* Color principal distinto del blanco */
    width: 300px;
    border-radius: 8px;
}

.btn_wid:hover {
    background-color: red !important; /* Color principal distinto del blanco */
}

.dia {
    font-size: 20px;
    display: block;
}

.hora {
    font-size: 16px;
    display: block;
}

.btn_wid, .dia, .hora {
    color: red; /* Color principal distinto del blanco */
}

.mrgn_rgt {
    margin-right: 12px;
}

.icono_hora {
    fill: red; /* Color principal distinto del blanco */
    margin-right: 16px;
    margin: 0px !important;
    padding: 0px !important;
}

.btn_wid:hover .dia,
.btn_wid:hover .hora,
.btn_wid:hover .icono_hora {
    color: white !important;
    fill: white !important;
}

.btn_dis {
    background-color: white !important;
    border: 4px solid gray !important;   /* Cuando el evento esté disabled es mejor que se quede gris */
    width: 300px;
    border-radius: 8px;
}

.btn_dis:hover {
    background-color: gray !important;   /* Cuando el evento esté disabled es mejor que se quede gris */
}

.dia_dis {
    font-size: 20px;
    display: block;
}

.hora_dis {
    font-size: 16px;
    display: block;
}

.dia_dis, .hora_dis {
    color: gray !important;
}

.icono_hora_dis {
    fill: gray;
}

.btn_dis:hover .dia_dis,
.btn_dis:hover .hora_dis,
.btn_dis:hover .icono_hora_dis {
    color: white !important;
    fill: white !important;
}

@media (max-width: 768px) {
    .mrgn_rgt {
        margin-right: auto;
    }

    .btn_dis:hover {
        background-color: white !important;
        border: 4px solid gray !important;
        width: 300px;
        border-radius: 8px;
    }

    .btn_dis:hover .dia_dis,
    .btn_dis:hover .hora_dis,
    .btn_dis:hover .icono_hora_dis {
        color: gray !important;
        fill: gray !important;
    }
}
</style>